<script setup>
import {reactive, onMounted, computed, ref} from "vue";
import JsonCSV from "vue-json-csv";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const form = ref(null);

const data = reactive({
  valid: true,
  loading: false,
  dataLoading: true,
  pending: null,
  finished: false,
  newPP: false,
  search: null,
  headers: [
    { title: 'Date Range', key: 'daterange' },
    { title: 'Gross', key: 'gross' },
    { title: 'Holdbacks', key: 'holdbacks' },
    { title: 'Released Holdbacks', key: 'holdbacksreleased' },
    { title: 'Adjustments', key: 'adjustments' },
    { title: 'Net', key: 'net' },
  ],
  items: [],
  newItem: {
    start: null,
    end: null,
    pay: null,
  },
  labels: {
    daterange: "Date Range",
    gross: "Gross",
    holdbacks: "Holdbacks",
    adjustments: "Adjustements",
    net: "Net",
    grossFormatted: "Gross Formatted"
  },
});

let csvData = computed(()=>{
  return data.items.map((item) => ({
    daterange: item.daterange,
    gross: item.gross,
    holdbacks: item.holdbacks,
    adjustments: item.adjustments,
    net: item.net
  }))
});

const getData = () => {
  ApiWrapper.get('pay-period', 'pay-periods')
      .then((response) => {
        if(response.items){
          data.items = response.items;
          data.finished = true
          if(!data.finished){
            data.finished = true
          }else{
            data.dataLoading = false
          }
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })

  ApiWrapper.get('pay-period', 'pay-periods-pending')
      .then((response) => {
        if(response.pending){
          data.pending = response.pending;
          if(!data.finished){
            data.finished = true
          }else{
            data.dataLoading = false
          }
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
}

const saveItem = () => {
  if (form.value.validate()) {
    data.loading = true;
    ApiWrapper.post('pay-period', 'create', {
          newPayPeriod: data.newItem,
        })
        .then((response) => {
          getData();
          discardItem();
          ToastUtil.successMsg('Created pay period');
        })
        .catch((err) => {
          ToastUtil.error(err);
        })
        .finally(()=>{
          data.loading = false;
        })
  }
}

const discardItem = () => {
  data.newItem.start = null;
  data.newItem.end = null;
  data.newItem.pay = null;
  data.newPP = false;
}

onMounted(()=>{
  getData();
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Pay Periods</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>

        <JsonCSV
            :data="data.items"
            name="Pay Periods.csv"
            :labels="data.labels"
        >
          <v-btn size="small" variant="elevated" color="primary">
            <v-icon> mdi-file-download </v-icon>
          </v-btn>
        </JsonCSV>

        <v-spacer></v-spacer>

        <v-btn
            v-if="!data.newPP && Permissions.checkPermissions(['pay-periods.create'])"
            variant="elevated"
            color="primary"
            size="small"
            dark
            absolute
            right
            @click="data.newPP = true"
        >New Pay Period</v-btn
        >
      </v-toolbar>

      <v-form
          ref="form"
          v-model="data.valid"
          lazy-validation
          v-if="data.newPP"
      >
        <v-card-subtitle>Type Date or Click on Icon</v-card-subtitle>
        <v-row>
          <v-col cols="4">
            <v-text-field
                class="ml-4"
                type="date"
                v-model="data.newItem.start"
                label="Start Date"
                :rules="[v => !!v || 'Start Date is required']"
            ></v-text-field>
            <v-text-field
                class="ml-4"
                type="date"
                v-model="data.newItem.end"
                label="End Date"
                :rules="[v => !!v || 'End Date is required']"
            ></v-text-field>
            <v-text-field
                class="ml-4"
                type="date"
                v-model="data.newItem.pay"
                label="Pay Date"
                :rules="[v => !!v || 'Pay Date is required']"
            ></v-text-field>
            <v-btn size="small" variant="elevated" class="ml-4" @click="saveItem" color="primary">
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn size="small" variant="elevated" class="ll-2" @click="discardItem" color="error">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <!-- <v-row v-if="this.newPP" class="px-5">
          <v-col cols="12" sm="3">
            <v-text-field
              type="date"
              v-model="newItem.start"
              label="Start Date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              type="date"
              v-model="newItem.end"
              label="End Date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              type="date"
              v-model="newItem.pay"
              label="Pay Date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-btn small class="px-2" @click="saveItem" color="primary">
              <v-icon color="white">mdi-plus</v-icon>
            </v-btn>
            <v-btn small class="px-2" @click="discardItem" color="error">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row> -->
      </v-form>

      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="data.search"
              append-inner-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="ml-4"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-card-actions class="ml-2" v-if="!data.dataLoading">
        <RouterLink :to="`/payperiod/pending`">
          Pending Disbursements: {{data.pending}}
        </RouterLink>
      </v-card-actions>
      <v-card-actions v-else>
        Loading Pending Disbursements...
      </v-card-actions>
      <v-data-table
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.dataLoading"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.daterange`]="{ item }">
          <RouterLink :to="`/payperiod/${item.id}`">
            {{ item.daterange }}
          </RouterLink>
        </template>
        <template v-slot:[`item.gross`]="{ item }">
          <span>{{ item.grossFormatted }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>